import { navigate } from "gatsby"
import React from "react"


class Language extends React.Component{
    handler(lang,path) {
      if (typeof window !== 'undefined') {


        localStorage.setItem('locale', JSON.stringify(lang))}
        navigate(path)
      }
    render() {

    return (
       <>
                            {this.props.locale === 'en' && 
                             <button onClick={  () =>  {this.handler('el', '/el')}}>EN</button>}
                             {this.props.locale === 'el' && 
                            <button onClick={ ()  => {this.handler('en', '/')}} >EL</button>}
                 </>
  )
    }
}



export default Language